<!-- Page -->
<div class="col no-overflow padding all full-width">
  <div class="row no-overflow">
    <!-- Kanban Queue POC -->
    <mat-card *ngIf="selectedTab.id === 0" class="no-overflow block fill padding all">
      <!-- Header -->
      <mat-card-header class="header">
        <mat-card-title class="title">My Queue</mat-card-title>
        <div class="controls">
          <mat-tab-group class="tabs" mat-stretch-tabs [selectedIndex]="0" (selectedTabChange)="onChangeTab($event)">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
          <button mat-flat-button (click)="openDialog()" class="margin left gray" [small]="true">New Structure</button>
        </div>
      </mat-card-header>

      <!-- Kanban -->
      <app-kanban-board> </app-kanban-board>
    </mat-card>

    <!-- Find Structures -->
    <mat-card *ngIf="selectedTab.id === 1" class="no-overflow fill padding all">
      <!-- Header -->
      <mat-card-header class="header">
        <mat-card-title class="title">Find Structures</mat-card-title>
        <div class="controls">
          <mat-tab-group class="tabs" mat-stretch-tabs [selectedIndex]="1" (selectedTabChange)="onChangeTab($event)">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
          <button mat-flat-button (click)="openDialog()" class="margin left gray" [small]="true">New Structure</button>
        </div>
      </mat-card-header>

      <mat-progress-bar *ngIf="isSearching" color="accent" mode="indeterminate"></mat-progress-bar>

      <div class="table-body">
        <table mat-table matSort class="mat-elevation-z0" [dataSource]="dataSource">
          <form [formGroup]="filterForm">
            <!-- Job Name Column -->
            <ng-container matColumnDef="jobName">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>Job Name</th>
              <td mat-cell *matCellDef="let element">
                <a *ngIf="!isSalesUser" (click)="selectStructure(element)">
                  {{ element.name }}
                </a>
                <span *ngIf="isSalesUser">{{ element.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="jobName-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #jobName
                    matInput
                    class="columnSearch"
                    formControlName="jobName"
                    (focus)="setSearchFocus('jobName')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- Structure Number Column -->
            <ng-container matColumnDef="structureNumber">
              <th class="customHeader" mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Name">
                Structure Number
              </th>
              <td mat-cell *matCellDef="let element">
                <button
                  class="margin left right bold"
                  title="Copy Structure Number"
                  mat-button
                  size="small"
                  (click)="copyStructureNumber(element)"
                >
                  {{ element.structureNumber }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="structureNumber-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #structureNumber
                    matInput
                    formControlName="structureNumber"
                    (focus)="setSearchFocus('structureNumber')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- City Column -->
            <ng-container matColumnDef="city">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>City</th>
              <td mat-cell *matCellDef="let element">
                {{ element.city }}
              </td>
            </ng-container>
            <ng-container matColumnDef="city-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input #city matInput class="columnSearch" formControlName="city" (focus)="setSearchFocus('city')" />
                </div>
              </th>
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="state">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>State</th>
              <td mat-cell *matCellDef="let element">
                {{ element.state }}
              </td>
            </ng-container>
            <ng-container matColumnDef="state-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #state
                    matInput
                    class="columnSearch"
                    formControlName="state"
                    (focus)="setSearchFocus('state')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- Country Column -->
            <ng-container matColumnDef="country">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>Country</th>
              <td mat-cell *matCellDef="let element">
                {{ element.country }}
              </td>
            </ng-container>
            <ng-container matColumnDef="country-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #country
                    matInput
                    class="columnSearch"
                    formControlName="country"
                    (focus)="setSearchFocus('country')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- topMasterKeyName Column -->
            <ng-container matColumnDef="topMasterKeyName">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>TMK Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.TopMasterKeyName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="topMasterKeyName-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #topMasterKeyName
                    matInput
                    class="columnSearch"
                    formControlName="topMasterKeyName"
                    (focus)="setSearchFocus('topMasterKeyName')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- TopMasterKeyKeyway Column -->
            <ng-container matColumnDef="topMasterKeySection">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>TMK KeyWay</th>
              <td mat-cell *matCellDef="let element">
                {{ element.TopMasterKeySection }}
              </td>
            </ng-container>
            <ng-container matColumnDef="topMasterKeySection-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #topMasterKeySection
                    matInput
                    class="columnSearch"
                    formControlName="topMasterKeySection"
                    (focus)="setSearchFocus('topMasterKeySection')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- keyWayFamily Column -->
            <ng-container matColumnDef="keyWayFamily">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>KeyWay Family</th>
              <td mat-cell *matCellDef="let element">
                {{ element.keywayFamily }}
              </td>
            </ng-container>
            <ng-container matColumnDef="keyWayFamily-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #keyWayFamily
                    matInput
                    class="columnSearch"
                    formControlName="keyWayFamily"
                    (focus)="setSearchFocus('keyWayFamily')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- Pin Count -->
            <ng-container matColumnDef="chamberCount">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>Pin Count</th>
              <td mat-cell *matCellDef="let element">
                {{ element.pinCount }}
              </td>
            </ng-container>
            <ng-container matColumnDef="chamberCount-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #chamberCount
                    matInput
                    class="columnSearch"
                    formControlName="chamberCount"
                    (focus)="setSearchFocus('chamberCount')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                {{ getStatusString(element.keySystems[0].statusId) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #status
                    matInput
                    class="columnSearch"
                    formControlName="status"
                    (focus)="setSearchFocus('status')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- Key Name -->
            <ng-container matColumnDef="keyName">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>Key Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.keyName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="keyName-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef>
                <div class="padding right">
                  <input
                    #keyName
                    matInput
                    class="columnSearch"
                    formControlName="keyName"
                    (focus)="setSearchFocus('keyName')"
                  />
                </div>
              </th>
            </ng-container>

            <!-- More Actions-->
            <ng-container matColumnDef="more">
              <th class="customHeader" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <div class="row flex-end align-center">
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu"
                    (click)="getReportStatus(row)"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu>
                    <div>
                      <span class="row align-center" *ngFor="let report of getStructureReports(row)">
                        <!--Overview Internal report-->
                        <span *ngIf="report.alwaysShow">
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === null"
                            [value]="report.id"
                            (click)="generateReport(row, report.id, false)"
                          >
                            {{ report.name }}
                          </button>
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === 1 || report.status === 2"
                            [value]="report.id"
                            [disabled]
                            (click)="$event.stopPropagation()"
                          >
                            <mat-spinner
                              class="padding right centerAlign"
                              [diameter]="25"
                              matTooltip="This report is currently generating."
                            ></mat-spinner>
                            {{ report.name }}
                          </button>
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === 3"
                            [value]="report"
                          >
                            <mat-icon
                              class="material-icons-outlined green centerAlign"
                              [matTooltip]="getDownloadTooltip(report)"
                              (click)="downloadReport(row, report); $event.stopPropagation()"
                              style="cursor: pointer;"
                              >download</mat-icon
                            >
                            <span (click)="generateReport(row, report.id, false); $event.stopPropagation()" style="cursor: pointer;">{{ report.name }}</span>
                          </button>
                          <button mat-menu-item class="flex" *ngIf="report.status === 4">
                            <mat-icon
                              class="material-icons-outlined red centerAlign"
                              matTooltip="An error has occured with this report. Click here to regenerate. If a problem continues, please contact support."
                              (click)="generateReport(row, report.id, true); $event.stopPropagation()"
                              style="cursor: pointer;"
                              >sync_problem</mat-icon
                            >
                            <span (click)="generateReport(row, report.id, false); $event.stopPropagation()" style="cursor: pointer;">{{ report.name }}</span>
                          </button>
                        </span>
                        <!--End Overview Internal report-->
                        <!--Report is ready to start generating download-->
                        <span *ngIf="!report.alwaysShow">
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === null && row.keySystems[0].statusId === 13"
                            [value]="report.id"
                            (click)="generateReport(row, report.id, false)"
                          >
                            {{ report.name }}
                          </button>
                          <!--Report is generating download-->
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === 1 || (report.status === 2 && row.keySystems[0].statusId === 13)"
                            [value]="report.id"
                            [disabled]
                            (click)="$event.stopPropagation()"
                          >
                            <mat-spinner
                              class="padding right centerAlign"
                              [diameter]="25"
                              matTooltip="This report is currently generating."
                            ></mat-spinner>
                            {{ report.name }}
                          </button>
                          <!--Report has generated and is now able to download-->
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === 3 && row.keySystems[0].statusId === 13"
                            [value]="report"
                          >
                            <mat-icon
                              class="material-icons-outlined green centerAlign"
                              [matTooltip]="getDownloadTooltip(report)"
                              (click)="downloadReport(row, report); $event.stopPropagation()"
                              style="cursor: pointer;"
                              >download</mat-icon
                            >
                            <span (click)="generateReport(row, report.id, false); $event.stopPropagation()" style="cursor: pointer;">{{ report.name }}</span>
                          </button>
                          <button
                            mat-menu-item
                            class="flex"
                            *ngIf="report.status === 4 && row.keySystems[0].statusId === 13"
                          >
                            <mat-icon
                              class="material-icons-outlined red centerAlign"
                              matTooltip="An error has occured with this report. Click here to regenerate. If a problem continues, please contact support."
                              (click)="generateReport(row, report.id, true); $event.stopPropagation()"
                              style="cursor: pointer;"
                              >sync_problem</mat-icon
                            >
                            <span (click)="generateReport(row, report.id, false); $event.stopPropagation()" style="cursor: pointer;">{{ report.name }}</span>
                          </button>
                        </span>
                      </span>
                    </div>
                  </mat-menu>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="more-filter">
              <th class="customHeader" mat-header-cell *matHeaderCellDef style="vertical-align: middle">
                <div class="row grow margin left bottom">
                  <mat-icon
                    *ngIf="!activeAdvancedFilters"
                    (click)="showAdvancedFilter = !showAdvancedFilter"
                    class="button"
                    matTooltip="Advanced Filters"
                    >filter_list</mat-icon
                  >

                  <mat-icon
                    *ngIf="activeAdvancedFilters > 0"
                    (click)="showAdvancedFilter = !showAdvancedFilter"
                    class="button"
                    matTooltip="Advanced Filters"
                    [matBadge]="activeAdvancedFilters"
                    matBadgeColor="warn"
                    matBadgeSize="small"
                    >filter_list</mat-icon
                  >

                  <mat-icon (click)="clearSearch()" class="margin left button" matTooltip="Clear all Filters"
                    >close</mat-icon
                  >
                </div>
              </th>
            </ng-container>
          </form>

          <ng-container matColumnDef="advancedFilter">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="12">
              <div class="margin top"></div>
              <overtur-monorepo-advanced-search
                [filterFormGroup]="filterForm"
                [filterControlNames]="advancedFilters"
                (focusSet)="setSearchFocus($event); setSearchString($event)"
              ></overtur-monorepo-advanced-search>
            </th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumnFilters; sticky: true"
            [ngClass]="{
              border: !showAdvancedFilter,
              bottom: !showAdvancedFilter
            }"
          ></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="['advancedFilter']; sticky: true"
            [ngClass]="{
              hidden: !showAdvancedFilter
            }"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div id="no-structures" class="center col margin lrg bottom" *ngIf="structures && structures.items.length === 0">
        <app-icon symbol="Clipboards"></app-icon>
        <p class="body-20" i18n>You don't have any Structures.</p>
      </div>

      <mat-divider></mat-divider>

      <mat-paginator
        class="paginator-wrapper"
        #structuresTablePaginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [pageIndex]="currentPage"
        [length]="totalRows"
        (page)="pageChanged($event)"
        showFirstLastButtons
        aria-label="structures"
      >
      </mat-paginator>
    </mat-card>

    <!-- Find Orders -->
    <mat-card *ngIf="selectedTab.id === 2" class="no-overflow fill padding all">
      <!-- Header -->
      <mat-card-header class="header">
        <mat-card-title class="title">Find Orders</mat-card-title>
        <div class="controls">
          <mat-tab-group class="tabs" mat-stretch-tabs [selectedIndex]="2" (selectedTabChange)="onChangeTab($event)">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
          </mat-tab-group>
          <button mat-flat-button (click)="openDialog()" class="margin left gray" [small]="true">New Structure</button>
        </div>
      </mat-card-header>

      <app-find-orders></app-find-orders>
    </mat-card>
  </div>
</div>
